import React from "react";
import { Callout } from "@vp/swan";
export const DropdownCallout = ({ callouts }) => {
    // Only render one callout in dropdown
    // Take the first callout as the highest priority one.
    const callout = callouts?.[0];
    if (!callout) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Callout, { key: callout.key, skin: callout.style ?? "info", emphasis: "low", ml: "3" }, callout.text));
};
//# sourceMappingURL=dropdown-callout.js.map